import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { SmoothScroll } from "@/components/alkeon/SmoothScroll";
import { CartDrawer } from "@/components/alkeon/CartDrawer";
import { AuthModal } from "@/components/alkeon/AuthModal";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import LegalImprint from "./components/alkeon/LegalImprint";
import PrivacyPolicy from "./components/alkeon/PrivacyPolicy";
import TermsAndReturns from "./components/alkeon/TermsAndReturns";

// Riporta automaticamente la pagina in cima ad ogni cambio rotta
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Rileva automaticamente se siamo nella sottocartella Atelier o nella root principale (A prova di futuro)
const getBasename = () => {
  return window.location.pathname.startsWith('/') ? '/' : '';
};

function App() {
  return (
    <BrowserRouter basename={getBasename()}>
      <ScrollToTop />
      <SmoothScroll>
        <AuthProvider>
          <CartProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/legal-imprint" element={<LegalImprint />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-and-returns" element={<TermsAndReturns />} />
            </Routes>
            <CartDrawer />
            <AuthModal />
          </CartProvider>
        </AuthProvider>
      </SmoothScroll>
      <Toaster theme="dark" position="bottom-center" toastOptions={{ className: "alkeon-toast" }} />
    </BrowserRouter>
  );
}

export default App;